import { depascalize } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";

export const getStatusName = (status: OrderStatus): string => {
    if (status === OrderStatus.Approved) return "Encoding";
    else {
        return depascalize(OrderStatus[status]);
    }
};
